import Vue from 'vue'
import Element from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import { Menu, MenuItem, Submenu, Tabs, TabPane, Row, Col, Backtop } from 'element-ui'
Vue.use(Element).use(Menu).use(MenuItem).use(Submenu).use(Tabs).use(TabPane).use(Row).use(Col).use(Backtop)